import { render, staticRenderFns } from "./Crouton.vue?vue&type=template&id=8815adb4&scoped=true&"
import script from "./Crouton.vue?vue&type=script&lang=js&"
export * from "./Crouton.vue?vue&type=script&lang=js&"
import style0 from "./Crouton.vue?vue&type=style&index=0&id=8815adb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8815adb4",
  null
  
)

export default component.exports